/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getCustomerAsnList } from "../fn/cbw/get-customer-asn-list";
import { GetCustomerAsnList$Params } from "../fn/cbw/get-customer-asn-list";
import { getCustomerPrefixList } from "../fn/cbw/get-customer-prefix-list";
import { GetCustomerPrefixList$Params } from "../fn/cbw/get-customer-prefix-list";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class CbwService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomerAsnList()` */
  static readonly GetCustomerAsnListPath = "/dashboard/cbw/asn/{customer_id}";

  /**
   * Get Customer Asn List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerAsnList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAsnList$Response(
    params: GetCustomerAsnList$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<number>>> {
    const obs = getCustomerAsnList(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Customer Asn List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerAsnList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerAsnList(params: GetCustomerAsnList$Params, context?: HttpContext): Promise<Array<number>> {
    const resp = this.getCustomerAsnList$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<number>>): Array<number> => r.body);
  }

  /** Path part for operation `getCustomerPrefixList()` */
  static readonly GetCustomerPrefixListPath = "/dashboard/cbw/prefix/{customer_id}";

  /**
   * Get Customer Prefix List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerPrefixList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPrefixList$Response(
    params: GetCustomerPrefixList$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<string>>> {
    const obs = getCustomerPrefixList(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Customer Prefix List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerPrefixList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerPrefixList(params: GetCustomerPrefixList$Params, context?: HttpContext): Promise<Array<string>> {
    const resp = this.getCustomerPrefixList$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<string>>): Array<string> => r.body);
  }
}
